<template>
  <div
    class="cursor-pointer"
    @click="showTooltip"
  >
    <img
      :name="String(_uid)"
      src="@/assets/images/pro.svg"
      :class="classIcon"
    >
    <aha-toggle-tip
      ref="upgrade-icon-tooltip"
      :to="String(_uid)"
      trigger="click"
      showIcon
      :text="text"
      :buttonText="buttonText"
      showClose
      hideTooltipAfterClick
      theme="dark"
      placement="top"
      @click="openPlanUpgradeModal"
    />
  </div>
</template>

<script>

export default {
  name: 'IconNeedUpgradePlanV2',
  props: {
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    classIcon: {
      type: String,
      default: '',
    },

  },
  methods: {
    openPlanUpgradeModal() {
      this.$emit('openPlanUpgradeModal')
    },
    showTooltip() {
      this.$refs['upgrade-icon-tooltip'].show()
    },
  },

}
</script>
